export const honeycombDataSpanish = {
  contentArray: [
    {
      ID: 1,
      tabTitle: 'Cambio de sistema',
      leftColumnTitle: 'Variables del sistema',
      scenarioParameters: {
        systemScale: 'Cuota de mercado: ~40%',
        systemScaleSub:
          'Gran cambio hacia la reutilización dentro de una infraestructura muy compartida',
        infrastructure: 'Embalaje colectivo',
        packaging: 'Embalaje colectivo',
        returnRate: '95% (permite reutilizar los envases ~15 veces)',
      },
      chartURL:
        'https://content.ellenmacarthurfoundation.org/m/86c9f70249b3c60/original/Scenario-1-Data-Vis.png',
      imageCaption:
        'Tramo final de transporte desde "clasificación y limpieza" hasta "rellenado"',
      mapURL:
        'https://content.ellenmacarthurfoundation.org/m/766ecebc97b7a2e4/original/Honeycomb-S1-map.jpg',
      vimeoURL:
        'https://player.vimeo.com/video/858925722?background=1&badge=0&autoplay=1&loop=1&autopause=0&player_id=0&app_id=58479',
    },
    {
      ID: 2,
      tabTitle: 'Acción en colaboración',
      leftColumnTitle: 'Variables del sistema',
      scenarioParameters: {
        systemScale: 'Cuota de mercado: ~10%',
        systemScaleSub:
          'Es posible mediante grandes cambios de volumen hacia la reutilización y el uso compartido de infraestructuras',
        infrastructure: 'Envases a medida',
        packaging: 'Medio',
        returnRate: '90% (permite reutilizar los envases ~10 veces)',
      },
      chartURL:
        'https://content.ellenmacarthurfoundation.org/m/7c979eb2ffa16a8/original/Scenario-2-Data-Vis.png',
      imageCaption:
        'Tramo final de transporte desde "clasificación y limpieza" hasta " rellenado"',
      mapURL:
        'https://content.ellenmacarthurfoundation.org/m/2efc5c03c6ff4f10/original/Honeycomb-S2-map.jpg',
      vimeoURL:
        'https://player.vimeo.com/video/858926532?background=1&badge=0&autoplay=1&loop=1&autopause=0&player_id=0&app_id=58479',
    },
    {
      ID: 3,
      tabTitle: 'Esfuerzo fragmentado',
      leftColumnTitle: 'Variables del sistema',
      scenarioParameters: {
        systemScale: 'Cuota de mercado: ~2%',
        systemScaleSub:
          'Debido a los bajos volúmenes y a la fragmentación de las infraestructuras',
        infrastructure: 'Envases a medida',
        packaging: 'Alta',
        returnRate: '80% (permite reutilizar los envases ~5 veces)',
      },
      chartURL:
        'https://content.ellenmacarthurfoundation.org/m/3743ea191732d95e/original/Scenario-3-Data-Vis.png',
      mapURL:
        'https://content.ellenmacarthurfoundation.org/m/21ac51832880fa0f/original/Honeycomb-S3-map.jpg',
      imageCaption:
        'Tramo final de transporte desde "clasificación y limpieza" hasta " rellenado"',

      vimeoURL:
        'https://player.vimeo.com/video/858926809?background=1&badge=0&autoplay=1&loop=1&autopause=0&player_id=0&app_id=58479',
    },
  ],
  visualisationButtons: [
    'Escenario visual',
    'Resultados de la modelización de escenarios',
  ],
  mapURLs: [
    'https://content.ellenmacarthurfoundation.org/m/766ecebc97b7a2e4/original/Honeycomb-S1-map.jpg',
    'https://content.ellenmacarthurfoundation.org/m/2efc5c03c6ff4f10/original/Honeycomb-S2-map.jpg',
    'https://content.ellenmacarthurfoundation.org/m/21ac51832880fa0f/original/Honeycomb-S3-map.jpg',
  ],
};
